<ng-template [ngIf]="showSection">
<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line *ngIf="pane.display_mode === 'row'" height="40px" width="100%"></loading-line>
</div>

  <app-skeleton *ngIf="showSkeleton && pane.display_mode !== 'row'" [stats]="'my-classes-users'" [class.mobile]="deviceService.isMobile()"></app-skeleton>

  <ng-template #contentBlock>
  <div *ngIf="!showSkeleton" class="content">
    <app-chapter [link]="blockTitle?.add_link" [title]="blockTitle.title"></app-chapter>

    <div *ngIf="users.length" class="scroll">
      <div class="tutor-list" [class.cell-row]="pane.display_mode === 'row'">
        <div *ngFor="let user of users; trackBy: trackByFn" class="tutor-item">
          <app-tutor-mini [display_mode]="pane.display_mode"
                          (clicked)="onShowUser($event)"
                          [user]="user">
          </app-tutor-mini>
        </div>
      </div>
    </div>

    <app-empty *ngIf="showEmptyContent" [empty]="emptyContent"></app-empty>
    <ng-container *ngIf="!users.length && pane.display_mode === 'row'" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    [routerLink]="isMeTenant ? null : ['/tutors']"
    [icon]="'header-teachers-stub'"
    [text]="isMeTenant ? 'my-classes.stub.stub2_1' : 'my-classes.stub.stub2'">
  </app-no-content-stub>
</ng-template>

<ng-template #classroomsTemplate>
  <div class="tutor-header" [class.mobile]="deviceService.isMobile()">
    <div class="cover-wrap">
      <on-ui-cover [cover]="userCover"></on-ui-cover>
    </div>

    <div class="info-wrap">
      <a [routerLink]="tutorAccountUrl()" class="back-title">{{ userFullName }}</a>
      <div class="stats">
        <ng-template [ngIf]="stats && stats.meetings_count">
          <span>{{'teacher-card.stats.classes' | translate}} {{stats.meetings_count}}</span>
        </ng-template>
        <ng-template [ngIf]="stats && stats.students_count">
          <span>{{'teacher-card.stats.students' | translate}} {{stats.students_count}}</span>
        </ng-template>
        <app-rating [stats]="stats" [label]="true" [user]="selectedTutor"></app-rating>
      </div>
    </div>
  </div>

  <ng-template ngFor let-item [ngForOf]="panesList" let-i="index" [ngForTrackBy]="trackByFn">
    <app-pane class="pane-from-tutors" [item]="item"></app-pane>
  </ng-template>
</ng-template>

<app-modal *ngIf="this.isShowClassrooms && !deviceService.isMobile()" (closed)="onBackToTeachers()">
  <app-modal-body>
    <ng-container *ngTemplateOutlet="classroomsTemplate"></ng-container>
  </app-modal-body>
  <app-modal-ad>
    <app-teacher-booking-surface-block [teacher]="selectedTutor"></app-teacher-booking-surface-block>
  </app-modal-ad>
</app-modal>

<app-mobile-modal *ngIf="this.isShowClassrooms && deviceService.isMobile()" (closed)="onBackToTeachers()">
  <app-mobile-modal-body>
    <ng-container *ngTemplateOutlet="classroomsTemplate"></ng-container>
  </app-mobile-modal-body>
</app-mobile-modal>
</ng-template>
